import styled from "styled-components";

export const Container = styled.div`
  width: 60px;
  height: 5px;
  background-color: red;
  height: 5px;
  border-radius: 15%;
`;